const lColoursBalls = 
[
    { primary: "#101010", secondary: "#101010" }, // Colours for when the ball has been potted (maybe just grey).

    { primary: "#e2e202", secondary: "#e2e202" }, // 1; solid; yellow.
    { primary: "#0000ff", secondary: "#0000ff" }, // 2; solid; light blue.
    { primary: "#dd1111", secondary: "#dd1111" }, // 3; solid; light red.
    { primary: "#6d056d", secondary: "#6d056d" }, // 4; solid; purple.
    { primary: "#ffae00", secondary: "#ffae00" }, // 5; solid; orange.
    { primary: "#025302", secondary: "#025302" }, // 6; solid; green.
    { primary: "#8b0000", secondary: "#8b0000" }, // 7; solid; dark red.

    { primary: "#000000", secondary: "#000000" }, // 8; solid; black.

    { primary: "#e2e201", secondary: "#ffffff" }, // 9; stripes; yellow.
    { primary: "#0000ff", secondary: "#ffffff" }, // 10; stripes; light blue.
    { primary: "#dd1111", secondary: "#ffffff" }, // 11; stripes; light red.
    { primary: "#6d056d", secondary: "#ffffff" }, // 12; stripes; purple.
    { primary: "#ffae00", secondary: "#ffffff" }, // 13; stripes; orange.
    { primary: "#025302", secondary: "#ffffff" }, // 14; stripes; green.
    { primary: "#8b0000", secondary: "#ffffff" }, // 15; stripes; dark red.
];

export default lColoursBalls;